<template>
    <template
        v-for="opts in options"
        :key="opts"
    >
      <BaseCheckbox
          :name="name"
          :label="opts"
          :is-required="isRequired"
          v-bind="{ ...$attrs }"
          :modelValue="modelValue"
          :value="opts"
          @update:modelValue="$emit('update:modelValue', $event)"
      />
    </template>
</template>

<script>
export default {
  props: {
    modelValue: {
      // type: [String, Number],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
}
</script>
